/* 搭配款式（Frequently bought together）— 归属 A。
   数据由 sections/xp-product-bundle-data.liquid 经 Section Rendering API 提供。
   价格全部是真实价格：本店没有捆绑折扣 app，不画划线价。 */
(function () {
  var CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: CUR,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function selectedItem(root) {
    var d = root.dataset;
    var product = root.closest('xp-product');
    var ready = product && product.current !== undefined;
    var variant = ready ? product.current : null;
    var quantity = Math.max(1, parseInt(product && product.qtyInput && product.qtyInput.value, 10) || 1);
    var img = variant && product.imgs && product.imgs[variant.media];
    var imageUrl = img && (img.getAttribute('data-src') || img.getAttribute('src'));
    if (imageUrl) {
      try { var u = new URL(imageUrl, location.origin); u.searchParams.set('width', '160'); imageUrl = u.href; } catch (e) {}
    }
    var labels = product ? Array.from(product.querySelectorAll('[data-option] button[aria-pressed="true"]')).map(function (b) { return b.dataset.label || b.dataset.value; }) : [];
    var item = {
      id: ready ? variant && variant.id : d.thisId,
      title: d.thisTitle,
      variant: labels.join(' · '),
      price: variant ? variant.price : parseInt(d.thisPrice, 10) || 0,
      img: imageUrl || d.thisImg,
      available: ready ? !!(variant && variant.available) : d.thisAvailable !== 'false',
      quantity: quantity,
      self: true
    };
    d.thisId = item.id || '';
    d.thisPrice = item.price;
    return item;
  }

  function itemNote(root, it) {
    return (it.self ? (root.dataset.tThisItem || 'This item') + ' · ' : '') +
      (it.variant && it.variant !== 'Default Title' ? it.variant + ' · ' : '') + 'Qty: ' + it.quantity;
  }

  function render(root, items) {
    var d = root.dataset;
    var all = [selectedItem(root)].concat(items);

    var html = '<p class="xp-eyebrow xp-bundle__h">' + esc(d.title) + '</p><ul class="xp-bundle__list" role="list">';
    all.forEach(function (it, i) {
      var id = 'xp-bundle-' + i + '-' + Math.abs(parseInt(it.id, 10) || i);
      html +=
        '<li class="xp-bundle__row">' +
        '<input class="xp-bundle__check" type="checkbox" id="' + id + '" value="' + esc(it.id) + '" checked' + (it.self ? ' disabled' : '') + '>' +
        '<label class="xp-bundle__label" for="' + id + '">' +
        (it.img ? '<img class="xp-bundle__img" src="' + esc(it.img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="xp-bundle__img xp-ph"></span>') +
        '<span class="xp-bundle__meta">' +
        (it.url ? '<a class="xp-bundle__title" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' : '<span class="xp-bundle__title">' + esc(it.title) + '</span>') +
        '<span class="xp-bundle__note xp-small">' + esc(itemNote(root, it)) + '</span>' +
        '</span>' +
        '<span class="xp-bundle__price xp-price">' + esc(money(it.price * it.quantity)) + '</span>' +
        '</label>' +
        '</li>';
    });
    html +=
      '</ul>' +
      '<div class="xp-bundle__foot">' +
      '<span class="xp-bundle__total"><span class="xp-small">' + esc(d.tTotal) + '</span> <b class="xp-price" data-bundle-total></b></span>' +
      '<button type="button" class="xp-btn xp-bundle__add" data-bundle-add><span data-bundle-add-label>' + esc(d.tAdd) + '</span></button>' +
      '</div><p class="xp-small xp-bundle__error" data-bundle-error role="status" hidden></p>';

    root.innerHTML = html;
    root.hidden = false;
    root._items = all;
    updateTotal(root);
  }

  function updateTotal(root) {
    if (!root._items) return;
    var self = selectedItem(root);
    root._items[0] = self;
    var row = root.querySelector('.xp-bundle__row');
    row.querySelector('.xp-bundle__check').value = self.id || '';
    row.querySelector('.xp-bundle__note').textContent = itemNote(root, self);
    row.querySelector('.xp-bundle__price').textContent = money(self.price * self.quantity);
    var img = row.querySelector('img');
    if (img && self.img) img.src = self.img;
    var boxes = root.querySelectorAll('.xp-bundle__check');
    var total = 0;
    var n = 0;
    boxes.forEach(function (b, i) {
      if (b.checked) {
        total += root._items[i].price * root._items[i].quantity;
        n++;
      }
    });
    var el = root.querySelector('[data-bundle-total]');
    if (el) el.textContent = money(total);
    var btn = root.querySelector('[data-bundle-add]');
    if (btn) btn.disabled = !!root._pending || n === 0 || !self.available;
    if (!root._pending && !self.available) root.querySelector('[data-bundle-add-label]').textContent = root.dataset.tSoldOut || 'Unavailable';
    else if (!root._pending && !root._labelTimer) root.querySelector('[data-bundle-add-label]').textContent = root.dataset.tAdd;
  }

  function addSelected(root) {
    if (root._pending) return;
    updateTotal(root);
    var btn = root.querySelector('[data-bundle-add]');
    var label = root.querySelector('[data-bundle-add-label]');
    var boxes = [].slice.call(root.querySelectorAll('.xp-bundle__check'));
    var picks = boxes.map(function (b, i) { return b.checked ? { id: root._items[i].id, quantity: root._items[i].quantity } : null; }).filter(Boolean);
    if (!picks.length || btn.disabled) return;

    clearTimeout(root._labelTimer);
    root._labelTimer = null;
    root._pending = true;
    root.setAttribute('aria-busy', 'true');
    var error = root.querySelector('[data-bundle-error]');
    error.hidden = true;
    btn.disabled = true;
    label.textContent = root.dataset.tAdding;

    /* Use the same section refresh and partial-failure recovery as the main ATC. */
    var request = window.XP && window.XP.cart ? window.XP.cart.add(picks) : fetch(root.dataset.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: picks }),
    })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || 'Unable to add these items. Please try again.'); return data; }); })
      .then(function () { window.location.assign(root.dataset.cartUrl || '/cart'); });
    request.then(function () {
        label.textContent = root.dataset.tAdded;
        root._labelTimer = setTimeout(function () { root._labelTimer = null; updateTotal(root); }, 1600);
      })
      .catch(function (err) {
        error.textContent = err.message || 'Unable to add these items. Check your cart before trying again.';
        error.hidden = false;
      })
      .finally(function () {
        root._pending = false;
        root.setAttribute('aria-busy', 'false');
        updateTotal(root);
      });
  }

  function load(root) {
    if (root.dataset.state) return;
    root.dataset.state = 'loading';
    var tryUrl = function (url, next) {
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(String(r.status))); })
        .then(function (t) {
          var doc = new DOMParser().parseFromString(t, 'text/html');
          /* 数据以 data-* 属性给过来，不是 JSON —— Liquid 手拼 JSON 遇到带查询参数的
             商品 URL 会丢逗号，整块解析失败（2026-09-07 踩过） */
          var items = [].slice.call(doc.querySelectorAll('[data-bundle-data] > li')).map(function (li) {
            return {
              id: li.dataset.id,
              title: li.dataset.title,
              variant: li.dataset.variant,
              price: parseInt(li.dataset.price, 10) || 0,
              priceHtml: li.dataset.priceHtml,
              img: li.dataset.img,
              url: li.dataset.url,
              quantity: 1,
            };
          }).filter(function (it) { return it.id && String(it.id) !== String(root.dataset.thisId); });
          if (!items.length && next) return tryUrl(next, null);
          return items;
        });
    };
    tryUrl(root.dataset.url, root.dataset.fallbackUrl)
      .then(function (items) {
        if (!items.length) { root.dataset.state = 'empty'; return; }
        render(root, items.slice(0, 2));
        root.dataset.state = 'loaded';
      })
      .catch(function () { root.dataset.state = 'error'; });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle]').forEach(function (root) {
      if (root._initialized) return;
      root._initialized = true;
      var product = root.closest('xp-product');
      if (product) product.addEventListener('product:selection', function () { updateTotal(root); });
      root.addEventListener('change', function (e) {
        if (e.target.classList.contains('xp-bundle__check')) updateTotal(root);
      });
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-bundle-add]')) addSelected(root);
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(root); }
        }, { rootMargin: '0px 0px 500px 0px' });
        io.observe(root);
      } else {
        load(root);
      }
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
